import React, { ReactNode } from 'react'

import type {
  ComponentStyles,
  ImportantComponentStyles,
  Theme,
} from '@pijma/hero-types'

import { ThemeContext } from './context'
import { useTheme } from './hooks'

export const Provider = <ITokens extends {}>(props: {
  theme?: Theme<ITokens>
  componentStyles?: ComponentStyles<ITokens>
  important?: ImportantComponentStyles<ITokens>
  children?: ReactNode
}) => {
  const parentContext = useTheme()
  const newContext = { ...parentContext }

  if (props.theme) {
    newContext.theme = { ...parentContext?.theme, ...props.theme }
  }

  if (props.componentStyles) {
    newContext.componentStyles = {
      ...parentContext?.componentStyles,
      ...props.componentStyles,
    }
  }

  if (props.important) {
    newContext.important = {
      ...parentContext?.important,
      ...props.important,
    }
  }

  if (props.theme?.fonts) {
    props.theme.fonts.forEach((loadFont: () => void) => loadFont())
  }

  return (
    <ThemeContext.Provider value={newContext}>
      {props.children}
    </ThemeContext.Provider>
  )
}

export const ThemeProvider = Provider
